import { useFormContext } from "react-hook-form";

import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { updateLocationImageCache } from "modules/LocationOverviewDashboard/components/General/components";
import { ApiInstance } from "utils/Api";

import type { LocationDetailFormPayload } from "modules/LocationOverviewDashboard/hooks";

export const useUploadLogoMutation = () => {
  const { setValue } = useFormContext<LocationDetailFormPayload>();

  return useTypedMutation({
    mutationFn: async (logoPhoto: File) => {
      const fd = new FormData();
      fd.append("file", logoPhoto);

      return (await ApiInstance.post("/dealers/logo/upload", fd, ENV.dealerBaseURL)).data.url;
    },
    onSuccess: (_, logo) => {
      updateLocationImageCache("logo", logo);
      setValue("logo", logo);
    }
  });
};
